import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import FilterSelect from './FilterSelect';
import SaveFilterSetting from './SaveFilterSetting';
import { isEmpty } from 'lodash-es';
import { storage } from '@/utils/utils';
import { DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY, DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY, DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY } from '@/pages/dashboard/_config/constant';

import '@/pages/dashboard/assets/scss/components/filterSelect.scss';
interface FilterSaveProps {
  gameCode: string; // 游戏code
  path: string; // 页面路径
  selectorSchemeList: Array<Object>; // 筛选器方法list
  getOutSelectorSchemeList: Function; // 外部请求筛选器方案
  isOutScheme: boolean; //是否外部定制化筛选器
  formValue: Object; // 筛选器值
  realInputList: Array<Object>; // 页面渲染筛选器list
  filterSchemeChange: Function; //方案更改方法
  filterSaveOnChange: Function; //方案更改方法
  selectedValue: Object; //选择方案值
  setSelectedValue: any;
  selector: Object; //接口返回页面筛选器
  filterModalInfo: { // 编辑弹窗
    filterModalType: string | 'edit' | 'add';
    filterModalVisible: boolean;
  };
  setFilterModalInfo: any;
  alignedType: string;
}

const FilterSave = (props: FilterSaveProps) => {
  const { gameCode, selectorSchemeList, getOutSelectorSchemeList, isOutScheme, formValue, realInputList, filterSchemeChange, selectedValue, setSelectedValue, selector, path, filterModalInfo, setFilterModalInfo, alignedType} = props;
  const [editFilter, setEditFilter] = useState({});
  const { filterModalType: type, filterModalVisible: visible } = filterModalInfo || {}
  useEffect(() => {
    // 用于编辑后能实时更新选中方案的内容
    const selectedVal = selectorSchemeList?.filter(item => item?.id === selectedValue?.id)?.[0] || {}
    setSelectedValue(selectedVal)
    // filterSchemeChange(selectedVal)
    !isEmpty(selectedValue) && filterSchemeChange(selectedVal)
    const filterStorageSave = storage.getItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY);
    if(selectedVal?.id && filterStorageSave?.id  && (filterStorageSave?.id === selectedVal?.id)) {
      const { userId } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};
      storage.setItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY, { ...selectedVal, userId, gameCode: gameCode })
    }
  }, [selectorSchemeList])

  return (
    <>
      <FilterSelect
        selectedValue={selectedValue}
        isOutScheme={isOutScheme}
        selectorSchemeList={selectorSchemeList}
        getOutSelectorSchemeList={getOutSelectorSchemeList}
        setFilterModalInfo={setFilterModalInfo}
        setEditFilter={setEditFilter}
        setSelectedValue={setSelectedValue}
        filterSchemeChange={filterSchemeChange}
      />
      {
        visible && <SaveFilterSetting
          type={type}
          path={path}
          isOutScheme={isOutScheme}
          editFilter={editFilter}
          selector={selector}
          visible={visible}
          inputList={realInputList}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          selectorSchemeList={selectorSchemeList}
          getOutSelectorSchemeList={getOutSelectorSchemeList}
          close={() => {
            setFilterModalInfo({
              filterModalType: '',
              filterModalVisible: false,
            })
            setEditFilter({})
          }}
          gameCode={gameCode}
          formValue={formValue} 
          alignedType={alignedType} />
      }
    </>
  );
}

export default connect((state: any) => {
  const { dashboard, dashboardSetting: { selectorSchemeList } } = state;
  return {
    gameCode: dashboard?.currentGame?.game_code || '',
    // selectorSchemeList,
  }
})(FilterSave);

